import api from '../api/client';

const register = async (data) => {
    const res = await api.post('/api/webhooks/register', data);
    return res?.data;
};

const list = async (appId) => {
    const res = await api.get('/api/webhooks/list', { params: { app_id: appId } });
    return res?.data?.data;
};

// One page for the data table: query = { page, limit, sort, dir, search, filter_status }.
const getPage = async (appId, query) => {
    const res = await api.get('/api/webhooks/list', { params: { app_id: appId, ...query } });
    return res?.data?.data;
};

const update = async (data) => {
    const res = await api.post('/api/webhooks/update', data);
    return res?.data;
};

const deleteWebhook = async (data) => {
    const res = await api.post('/api/webhooks/delete', data);
    return res?.data;
};

const rotateSecret = async (data) => {
    const res = await api.post('/api/webhooks/rotate-secret', data);
    return res?.data;
};

const getDeliveries = async (webhookId, params = {}) => {
    const res = await api.get(`/api/webhooks/${webhookId}/deliveries`, { params });
    return res?.data;
};

const test = async (data) => {
    const res = await api.post('/api/webhooks/test', data);
    return res?.data;
};

const webhooksService = { register, list, getPage, update, deleteWebhook, rotateSecret, getDeliveries, test };
export default webhooksService;
